import { useQuery } from '@apollo/client/react';

import { GET_BROCHURE_REPORT } from './brochureReportsQueries';

export const useBrochureReport = (listingId: string | undefined) => {
  const { data, error, loading, refetch } = useQuery(GET_BROCHURE_REPORT, {
    variables: { id: listingId ?? '' },
    skip: listingId == null || listingId === '',
  });

  return {
    brochureReport: data?.lots_by_pk ?? null,
    error,
    loading,
    refetch,
  };
};
